import type { UserSidebarState } from './userSidebarTypes';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { User } from '../../appTypes';

export const initialState: UserSidebarState = {
    selectedUser: {
        email: '',
        firstName: '',
        lastName: '',
        groups: undefined,
    },
    persistedUser: {
        email: '',
        firstName: '',
        lastName: '',
        groups: undefined,
    },
    showConfirmation: false,
    showDeleteConfirmation: false,
};

const userSidebarSlice = createSlice({
    name: 'userSidebarSlice',
    initialState,
    reducers: {
        deleteUserSuccess(state) {
            state.showDeleteConfirmation = false;
        },
        deleteUserError() {},

        saveUserSuccess() {},
        saveUserError() {},

        setNewFirstName(state, action: PayloadAction<string>) {
            state.selectedUser.firstName = action.payload;
        },

        setNewLastName(state, action: PayloadAction<string>) {
            state.selectedUser.lastName = action.payload;
        },

        setNewEmail(state, action: PayloadAction<string>) {
            state.selectedUser.email = action.payload;
        },

        setNewGroups(state, action: PayloadAction<string[]>) {
            state.selectedUser.groups = action.payload;
        },

        hydrateFromUser(state, action: PayloadAction<User>) {
            state.selectedUser = {
                email: action.payload.email ?? '',
                phoneNumber: action.payload.phone_number ?? undefined,
                firstName: action.payload.first_name,
                lastName: action.payload.last_name,
                groups: action.payload.group_ids,
            };
            state.persistedUser = {
                email: action.payload.email ?? '',
                phoneNumber: action.payload.phone_number ?? undefined,
                firstName: action.payload.first_name,
                lastName: action.payload.last_name,
                groups: action.payload.group_ids,
            };
        },

        resetMutations(state) {
            state.selectedUser.groups = undefined;
        },

        resetState() {
            return initialState;
        },

        showDeleteConfirmation(state, action: PayloadAction<boolean>) {
            state.showDeleteConfirmation = action.payload;
        },

        showConfirmation(state, action: PayloadAction<boolean>) {
            state.showConfirmation = action.payload;
        },
    },
});

export default userSidebarSlice;
